const cards = [
  {
    title: '豆瓣Top250精选合集',
    desc: '收录豆瓣评分最高的250部经典电影，影史名作一网打尽，高清修复版本畅享最佳画质。',
    tag: '经典必看',
    tagColor: 'accent',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20cinematic%20collage%20of%20classic%20film%20scenes%20with%20warm%20golden%20tones%2C%20vintage%20movie%20poster%20aesthetic%2C%20elegant%20film%20reel%20texture%2C%20soft%20dramatic%20lighting%2C%20curated%20collection%20vibe&width=640&height=400&seq=card-douban-top250&orientation=landscape',
  },
  {
    title: '2024年度高分盘点',
    desc: '回顾过去一年最受好评的影视作品，涵盖各大电影节获奖影片与观众票选最佳。',
    tag: '年度精选',
    tagColor: 'primary',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20modern%20elegant%20award%20ceremony%20atmosphere%20with%20warm%20spotlight%20and%20golden%20confetti%2C%20sophisticated%20dark%20backdrop%20with%20coral%20accent%20lights%2C%20premium%20entertainment%20aesthetic&width=640&height=400&seq=card-2024-review&orientation=landscape',
  },
  {
    title: '悬疑烧脑精选片单',
    desc: '精心挑选的高分悬疑推理影片，反转不断的剧情让你猜不到结局，烧脑爱好者必收。',
    tag: '高分悬疑',
    tagColor: 'secondary',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20cinematic%20scene%20with%20dramatic%20shadows%20and%20warm%20amber%20light%20streaming%20through%20blinds%2C%20mystery%20noir%20atmosphere%2C%20elegant%20suspenseful%20composition&width=640&height=400&seq=card-mystery-thriller&orientation=landscape',
  },
  {
    title: '科幻巨制视觉盛宴',
    desc: '从赛博朋克到太空史诗，精选视觉效果震撼的科幻大片，带您探索无限的想象世界。',
    tag: '视效震撼',
    tagColor: 'accent',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20futuristic%20abstract%20composition%20with%20warm%20neon%20glow%20and%20deep%20space%20background%2C%20sleek%20geometric%20patterns%2C%20cinematic%20sci-fi%20atmosphere%20with%20coral%20and%20amber%20highlights&width=640&height=400&seq=card-scifi-epic&orientation=landscape',
  },
  {
    title: '国产原创力量特辑',
    desc: '聚焦优秀华语影视创作，从文艺片到商业大片，展现中国影视人的才华与创造力。',
    tag: '国产佳作',
    tagColor: 'primary',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20warm%20artistic%20composition%20with%20traditional%20Chinese%20aesthetic%20elements%20blended%20with%20modern%20cinema%20texture%2C%20elegant%20brushstroke%20patterns%2C%20soft%20golden%20lighting&width=640&height=400&seq=card-chinese-cinema&orientation=landscape',
  },
  {
    title: '治愈系温情电影合集',
    desc: '温暖人心的故事、治愈心灵的画面，精选最感人的温情电影，适合一个人静静品味。',
    tag: '温暖推荐',
    tagColor: 'secondary',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20soft%20warm%20cozy%20atmosphere%20with%20golden%20sunlight%20through%20window%2C%20gentle%20bokeh%20effect%2C%20peaceful%20and%20comforting%20composition%2C%20elegant%20minimal%20design&width=640&height=400&seq=card-heartwarming&orientation=landscape',
  },
  {
    title: '必看动作大片系列',
    desc: '肾上腺素飙升的动作电影合集，从经典港片到好莱坞巨制，精彩打斗场面一应俱全。',
    tag: '热血动作',
    tagColor: 'accent',
    imgSrc: 'https://readdy.ai/api/search-image?query=A%20dynamic%20cinematic%20action%20scene%20with%20dramatic%20warm%20lighting%20and%20motion%20blur%2C%20intense%20atmosphere%2C%20golden%20and%20coral%20color%20palette%2C%20elegant%20action%20movie%20aesthetic&width=640&height=400&seq=card-action-movies&orientation=landscape',
  },
];

export default function CardsSection() {
  const getTagClasses = (color: string) => {
    switch (color) {
      case 'accent':
        return 'bg-accent-100 text-accent-700';
      case 'primary':
        return 'bg-primary-100 text-primary-700';
      case 'secondary':
        return 'bg-secondary-100 text-secondary-700';
      default:
        return 'bg-accent-100 text-accent-700';
    }
  };

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队精心甄选，为您呈现最值得观看的精品影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 7).map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden hover:shadow-sm transition-all duration-200 cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${getTagClasses(item.tagColor)}`}>
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}